import {FC, useState} from 'react';
import Text from '@atoms/Text';
import ModulesTable from '@organisms/ModulesTable';
import EditTestCoverageModal from '@organisms/modals/EditTestCoverageModal';
import {IModule, ISubsystem, ICell} from '@types';
import AddEditModuleModal from '@organisms/modals/AddEditModuleModal';
import {SubsystemBlockWrapper, SubsystemTitle} from '@pages/EditSystemPlanPage.styles';
import DeleteModuleModal from '@organisms/modals/DeleteModuleModal';

export interface SubsystemDetailsBlockProps {
  subsystem: ISubsystem;
  addCellForPlan?: (cellData: {
    coverage: number;
    auto_coverage: number;
    module_id: number;
    subsystem_id: number;
    test_type_id: number;
  }) => void;
  readOnly?: boolean;
}

export const SubsystemDetailsBlock: FC<SubsystemDetailsBlockProps> = ({
  subsystem,
  addCellForPlan,
  readOnly = false,
}) => {
  const [showEditTestCoverage, setShowEditTestCoverage] = useState(false);
  const [showAddModule, setShowAddModule] = useState(false);
  const [showDeleteModule, setShowDeleteModule] = useState(false);
  const [selectedModule, setSelectedModule] = useState<IModule | undefined>();
  const [selectedTest, setSelectedTest] = useState<ICell | undefined>();

  const onEditTest = (module: IModule, cell: ICell) => {
    setSelectedModule(module);
    setSelectedTest(cell);
    setShowEditTestCoverage(true);
  };

  return (
    <SubsystemBlockWrapper key={`edit-plan-subsystem-${subsystem.id}`}>
      <SubsystemTitle>
        <Text text={`${subsystem.id}. ${subsystem.name}`} type="titleR" />
      </SubsystemTitle>
      <ModulesTable
        modules={subsystem.modules}
        onAddModule={() => {
          setSelectedModule(undefined);
          setShowAddModule(true);
        }}
        onEditModule={module => {
          setSelectedModule(module);
          setShowAddModule(true);
        }}
        onSortTests={() => {}}
        onEditTest={onEditTest}
        readOnly={readOnly}
      />
      <EditTestCoverageModal
        isOpened={showEditTestCoverage}
        onCloseRequest={() => {
          setShowEditTestCoverage(false);
          setSelectedTest(undefined);
          setSelectedModule(undefined);
        }}
        module={selectedModule}
        test={selectedTest}
        forPlan
        addCellForPlan={cell_data => {
          if (addCellForPlan) addCellForPlan({...cell_data, subsystem_id: subsystem.id});
        }}
      />
      {!readOnly && (
        <AddEditModuleModal
          isOpened={showAddModule}
          onCloseRequest={() => {
            setShowAddModule(false);
            setSelectedModule(undefined);
          }}
          onDelete={() => {
            setShowAddModule(false);
            setShowDeleteModule(true);
          }}
          module={selectedModule}
          subsystem_id={subsystem.id}
        />
      )}
      {!readOnly && (
        <DeleteModuleModal
          isOpened={showDeleteModule}
          onCloseRequest={() => {
            setShowAddModule(false);
            setSelectedModule(undefined);
          }}
          module={selectedModule}
        />
      )}
    </SubsystemBlockWrapper>
  );
};

export default SubsystemDetailsBlock;
